const prettyAmount = (amount, digits) => {
  amount = Number(amount)
  if (digits == null) digits = 2
  return amount.toFixed(amount % 1 ? digits : 0)
}

export default prettyAmount
